import { render, staticRenderFns } from "./SignatureScreen.vue?vue&type=template&id=689f8d38"
import script from "./SignatureScreen.vue?vue&type=script&lang=js"
export * from "./SignatureScreen.vue?vue&type=script&lang=js"
import style0 from "./SignatureScreen.vue?vue&type=style&index=0&id=689f8d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports